import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {formatPhoneNumber} from "../../../vendors/utils/common";

interface OwnProps {

}

interface ConnectStateProps {
}

interface ConnectDispatchProps {
}


const Info = (props: any) => {
    const {User} = props;
    return (
        <Fragment>
            <div className='d-flex flex-column profile-info-main mt-3 mt-sm-0'>
                <p className='mb-2 text-center text-sm-left'>{User.first_name} {User.last_name}</p>
                {User.business_name && <p className='mb-0 text-center text-sm-left'>{User.business_name}</p>}
                <div className='divider'/>
                <div className='email mb-2'>
                    <span>Email</span>
                    <p>{User.email}</p>
                </div>
                <div className='phone' >
                    <span>Phone Number</span>
                    <p>{formatPhoneNumber(User.phone)}</p>
                </div>
            </div>
        </Fragment>
    );
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User} = state;
    return {
        User
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Info);


